import {createFeatureSelector} from '@ngrx/store';
import {FEATURE_KEY} from './feature-key';

export const selectIntroductionState = createFeatureSelector(FEATURE_KEY)
